import { createApp } from 'vue'
import 'normalize.css'
import App from './App.vue'

createApp(App).mount('#app')
